import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const LivePriceUpdates: React.FC = () => {
  const { t } = useTranslation();
  const [price, setPrice] = useState<number | null>(null);

  const fetchPrice = async () => {
    try {
      const res = await fetch('https://api.coingecko.com/api/v3/simple/price?ids=solana&vs_currencies=usd');
      if (!res.ok) throw new Error('Network response was not ok');
      const data = await res.json();
      setPrice(data.solana.usd);
    } catch (err) {
      console.error('Failed to fetch SOL price', err);
    }
  };

  useEffect(() => {
    fetchPrice();
    const interval = setInterval(fetchPrice, 60000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="text-sm text-gray-400">
      {price === null
        ? t('livePrice.loading', 'Loading price...')
        : `${t('livePrice.label', 'SOL Price')}: $${price.toFixed(2)}`}
    </div>
  );
};

export default LivePriceUpdates; 